import { render, staticRenderFns } from "./SecurityView.vue?vue&type=template&id=87299012&scoped=true"
import script from "./SecurityView.vue?vue&type=script&lang=js"
export * from "./SecurityView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87299012",
  null
  
)

export default component.exports